<!-- Revised on 2025/10/16 by mnavarro -->
<template>
  <div class="dropdown d-inline">
    <Button id="importStatusFilter" color="primary" :title="$t('key_filter_status')" class="dropdown-toggle ms-2 " :variant="optionSelected == '' ? 'outline' : 'fill'"
            data-bs-toggle="dropdown" aria-expanded="false">
      <i class="fa-solid fa-cloud-arrow-up me-1" aria-hidden="true"></i>
    </Button>
    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="importStatusFilter">
      <li>
        <button class="dropdown-item border-radius-md text-success" :class="[optionSelected=='true'?'active-item':'']" type="button" @click="handleClick('true')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-cloud-arrow-up me-3 text-success"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_sga_registered_filter_option_yes') }}</span>
        </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-error" :class="[optionSelected=='false'?'active-item':'']" type="button" @click="handleClick('false')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-triangle-exclamation me-3 text-error"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_sga_registered_filter_option_no') }}</span>
        </button>
      </li>
      <li>
        <hr class="horizontal dark my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-clearfilter" type="button" @click="handleClick('')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-eraser me-3 text-clearfilter"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_clear_filters') }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

import Button from "@/picko/generic_components/Button.vue";

export default {
  name: "SgaRegisteredFilter",
  components: {
    Button
  },
  props: {
    filterSgaRegistered: {
      type: String,
      default: () => ''
    }
  },
  emits: ['sga-registered-filter-change'],
  data() {
    return {
      optionSelected: this.filterSgaRegistered
    }
  },
  watch: {
    filterSgaRegistered() {
      this.optionSelected = this.filterSgaRegistered;
    }
  },
  methods: {
    handleClick(newOption) {
      this.optionSelected = newOption;
      this.$emit('sga-registered-filter-change', newOption);

      const dropdownElement = document.querySelector('.dropdown-menu.show');
      if (dropdownElement) {
        dropdownElement.classList.remove('show');
      }
    }
  }
}

</script>
